import React from 'react';
// extra svg components
import AssessmentOption from './assessmentOption.Component';
import AssessmentQuestion from './assessmentQuestion.Component';
import {Animated} from 'react-animated-css'


const QuestionCollection = (props) => {
    function renderAnswerOptions(key) {
        return (
          <AssessmentOption
            key={key.AnswerCopy + key.questionId}
            answerContent={key.AnswerCopy}
            answerType={key.id}
            answer={props.answer}
            questionId={props.questionId}
            onAnswerSelected={props.onAnswerSelected}
            // prop for number of current qn
            currentQuestion = {props.currentQuestion}
          />
        );
    }
    return (
        <div className="quiz" style={{width: "100%"}}>
            <Animated animationIn="slideInRight" animationOut="slideOutLeft" isVisible={true} animationInDuration={800}>
              <AssessmentQuestion content={props.question} qnNumber = {props.currentQuestion} />
            </Animated>
            <ul className="answerOptions">
                {props.answerOptions.map(renderAnswerOptions)}
   
            </ul>


        </div>
      );
}



export default QuestionCollection;


// WEBPACK FOOTER //
// ./src/common/questionCollection.Component.tsx